import { makeStyles } from '@material-ui/core';

const tableStyle = makeStyles((theme) => {
  return {
    boldText: {
      fontWeight: 'bold',
    },
  };
});

export default tableStyle;